import { call, put, takeEvery } from 'redux-saga/effects';
import { CREATE_USER_PHONE_REQUEST } from '../../constants/user_phones.constants';
import { createUserPhone } from '../../../requests/user_phones_requests/create_user_phone_request';
import { createUserPhoneRequestSuccess, createUserPhoneRequestFailure } from '../../actions/user_phones_actions/create_user_phone.actions';
import { message_success, message_error } from '../../../../../../components/Message';

function* createUserPhoneRequest({ id, phone, name }) {
    const { result, options, msg } = yield call(createUserPhone, id, name, phone);
    if (result) {
        yield put(createUserPhoneRequestSuccess(options.person.phones));
        message_success('New phone created successfully!');
    } else {
        yield put(createUserPhoneRequestFailure(msg));
        message_error(msg);
    }
}

export default function* createUserPhoneSaga() {
    yield takeEvery(CREATE_USER_PHONE_REQUEST, createUserPhoneRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/sagas/user_phones_sagas/create_user_phone.saga.js